module.exports = __webpack_public_path__ + "static/fonts/iconfont.d7e522fe.ttf";